import React, { useState } from 'react';
import { Upload, Icon, Modal, } from 'antd';
import './style.less';

interface ImgSelectProps {
  handleChange?: (...args: any) => void,
  handleBase64?: (...args: any) => void,
  limit?: number,
  multi?: boolean,
  handleRemove?: (...args: any) => void,
  outerImgList?: any[] | undefined,
};

const clsPrefix = "tb-img-select";

export function getBase64(img: Blob, callback: any) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export function getimg(file: Blob): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      var reader = new FileReader()
      if (file) {
        reader.onloadend = function (e) {
          resolve(reader.result)
        }
        reader.onerror = function () {
          reject("load file error")
        }
        reader.readAsDataURL(file)
      } else {
        reject("file not found")
      }
    } catch (e) {
      reject("file not found")
    }
  })
}

export async function toBase64(img: Blob) {
  const reader = await getimg(img)
}

const ImgSelect:React.FC<ImgSelectProps> = ({
  handleChange = () => null,
  handleBase64 = () => null,
  limit = 1, 
  multi = false,
  handleRemove = () => null,
  outerImgList = []
}) => {
  // const [ imgList, setImgList ] = useState<any[] | undefined>(outerImgList);
  const [ loading, setLoading ] = useState(false);
  const [ previewVisible, setPreviewVisible ] = useState(false);
  const [ previewImage, setPreviewImage ] = useState<string>('');

  const uploadButton = (
    <div className={`${clsPrefix}__upload`}>
      <Icon 
        type={loading ? "loading" :"cloud-upload" }
        style={{ display: 'block', fontSize: '22px', color: '#C5C5C5' }} 
      />
      <div>选择图片</div>
    </div>
  )
  
  function handleSelectChange(info: any) {
      handleChange(info.fileList)

      if (!info.file) {
        setLoading(true);
        return;
      }

      if (info.file.status === 'removed') {
        return;
      }
      // Get this url from response in real world.
      if (info.file) {
        getBase64(info.file, (imageUrl:any) => {
          setLoading(false);
          handleBase64(imageUrl); 
        });
      }
  }

  function handleRemoveFile() {
    handleRemove()
  }

  async function handlePreview (file: any) {
    await getBase64(file.originFileObj, (url: string) => {
      setPreviewImage(url);
    });

    setPreviewVisible(true);
  };

  function handleCancel() { 
    setPreviewVisible(false); 
  }
  return (
    <>
      <Upload
        multiple={multi}
        listType="picture-card"
        accept=".png,.jpeg,.jpg"
        fileList={outerImgList}
        beforeUpload={() => false}
        onChange={(info) => handleSelectChange(info)}
        onRemove={() => handleRemoveFile()}
        onPreview={handlePreview}
      >
        {outerImgList && outerImgList.length >= limit ? null : uploadButton}  
      </Upload>
      <Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
}

export default ImgSelect;
